import { Injectable, Inject, ChangeDetectorRef } from '@angular/core';

interface CycleSignUpState {
  courseTrack: any;
  showSignUpConfirmation: boolean;
}

@Injectable({ providedIn: 'root' })
export class AcademyCycleSignUpService {
  isSigningUp = false;

  constructor(
    @Inject('CourseTrackService') private CourseTrackService: any,
    @Inject('AlertService') private AlertService: any,
  ) {}

  async signUp(
    courseTrack: any,
    user: any,
    cdr: ChangeDetectorRef,
  ): Promise<CycleSignUpState | null> {
    if (this.isSigningUp) return null;
    this.isSigningUp = true;
    try {
      const cycleRes = await this.CourseTrackService
        .getPendingAcademyTestCycleByLevel(courseTrack.academy_level);
      const signUpRes = await this.CourseTrackService.addTesterToTestCycle({
        test_cycle_id: cycleRes.data.test_cycle_id,
        platform_user_id: user.platform_id,
        course_track_id: courseTrack.id,
      });
      const completed = signUpRes?.data?.user_has_completed_course_track ?? false;
      const isLv5 = courseTrack.academy_level === 5;
      return {
        courseTrack: {
          ...courseTrack,
          user_has_applied_to_test_cycle: true,
          user_has_completed_course_track: completed,
          user_is_currently_in_practice_cycle: true,
          ...(isLv5 && { user_is_currently_in_lv_5_cycle: true }),
        },
        showSignUpConfirmation: true,
      };
    } catch (error: any) {
      if (error.status === 406) {
        this.AlertService.addDanger(
          'Please pass the preceding practice test cycle to sign in to this one!',
        );
      } else {
        this.AlertService.addDanger(
          'Sorry, there was a problem adding you to the test cycle. Please try again later.',
        );
      }
      return null;
    } finally {
      this.isSigningUp = false;
      cdr.markForCheck();
    }
  }
}
